import script from "./TressAccountForgottenPasswordForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccountForgottenPasswordForm.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccountForgottenPasswordForm.vue?vue&type=style&index=0&id=9a338b9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a338b9c"]])

export default __exports__